import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import {
  NavigationMenu,
  NavigationMenuViewport,
} from "../ui/navigationmenu";
import { NavbarLogo } from "./NavComponents/NavbarLogo";
import { NavbarDesktopMenu } from "./NavComponents/NavbarDesktopMenu";
import { NavbarMobileMenu } from "./NavComponents/NavbarMobileMenu";

function Navbar() {
  const [openMobileMenus, setOpenMobileMenus] = useState({});
  const [scrolled, setScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = (label) => {
    setOpenMobileMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const closeAllMobileMenus = () => setOpenMobileMenus({});

  const handleGetStartedClick = () => {
    navigate("/", { state: { scrollToId: "book-now-section" } });
    closeAllMobileMenus();
  };

  return (
    <NavigationMenu
      onValueChange={(value) => setIsDropdownOpen(value === "Products")}
     className={`sticky top-0 z-50 w-full transition-all duration-300 ease-out ${
  scrolled
    ? "bg-slate-950/80 backdrop-blur-xl border-b border-white/10 shadow-2xl shadow-black/30"
    : "bg-slate-950/60 backdrop-blur-md border-b border-white/[0.06]"
}`}
    >
      <div className="relative w-full">
        <div className="absolute bottom-0 left-0 h-[1px] w-full bg-gradient-to-r from-transparent via-blue-500/40 to-transparent" />
        <div className="absolute -bottom-8 left-1/2 h-[30px] w-[500px] -translate-x-1/2 bg-blue-600/10 blur-[50px] pointer-events-none" />

        <div className="container mx-auto flex items-center px-6 py-4">
          <NavbarLogo href="/" />

          <div className="flex h-full w-full flex-1 items-center justify-center">
            <NavbarDesktopMenu setIsDropdownOpen={setIsDropdownOpen} />
          </div>

          <div className="hidden md:flex flex-shrink-0 items-center">
            <Button
              onClick={handleGetStartedClick}
              className="relative overflow-hidden rounded-lg border-0 bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-2 font-medium tracking-wide text-white shadow-lg shadow-blue-900/30 transition-all duration-300 hover:scale-105 hover:from-blue-500 hover:to-purple-500 hover:shadow-blue-800/40 hover:shadow-xl"
            >
              <span className="relative z-10 flex items-center gap-2">
                Get Started
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="transition-transform duration-300 group-hover:translate-x-1"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </span>
            </Button>
          </div>

          <NavbarMobileMenu
            openMobileMenus={openMobileMenus}
            toggleMobileMenu={toggleMobileMenu}
            closeAllMobileMenus={closeAllMobileMenus}
            handleGetStartedClick={handleGetStartedClick}
          />
        </div>

        <div className="absolute left-0 top-full z-50 flex w-full justify-center">
          <NavigationMenuViewport className="w-full md:w-[var(--radix-navigation-menu-viewport-width)]" />
        </div>
      </div>
    </NavigationMenu>
  );
}
export default Navbar;
